import * as React from "react";
import {Link} from "react-router-dom";
import {PROCESS_PAY_OFF_BALANCE, productHelper, resourcesHelper} from "@falcon/services";
import {getAmountToDisplay} from "../../../../../../CommonFunctions";
import {isCustomerPortalMtc} from "@falcon/plugin-falcon-journey";

interface IProps {
    interaction: any;
    policyNumber: string;
    payOffAmountWithRemainingInterest?: number;
    remainingInterest?: number;
    reuseCard: boolean;
}

export class AccountBalanceSection extends React.Component<IProps> {

    public render() {
        const remainingAmountPresent: boolean = Math.abs(this.props.payOffAmountWithRemainingInterest!) !== 0;
        const isHome: boolean = productHelper.isHome(this.props.interaction);
        const productWording: string = isHome ? "home" : "car";
        const product: any = this.props.interaction.product;
        const isDirectDebit = this.props.interaction?.paymentDetails?.paymentType === "directDebit";
        const isMTC = this.props.interaction?.process && isCustomerPortalMtc(this.props.interaction?.process);
        const reuseCard = this.props.reuseCard;
        const disableButton: boolean =  window.sessionStorage.getItem("referrerJourney") === PROCESS_PAY_OFF_BALANCE;
        const buttonTheme = resourcesHelper.THEME === "ALLIANZ" ? "btn-white-dashboard" : "btn-primary";

        let payOffUrl: string;
        if (isDirectDebit || isMTC) {
            if (reuseCard) {
                payOffUrl = `/dashboard/${this.props.policyNumber}/payOffBalance`;
            } else {
                payOffUrl = `/dashboard/${this.props.policyNumber}/payOffBalance/newCard`;
            }
        } else {
            payOffUrl = `/journey/init/product/${product}/process/mtaPayOffBalance/presetPage/${this.props.interaction?._id}`;
        }

        return (
            <div className="text-center my-4 payment-details-section grid-col-1-2 icon-money-exchange-before">
                <div className="dashboard-panel-title my-3">Account balance</div>
                <div className="justify-content-center mt-2 grid-col-2">
                    <div>
                        <span id="account-balance" className="font-weight-semi-bold my-3 grid-col-2">-{getAmountToDisplay(Math.abs(this.props.payOffAmountWithRemainingInterest!))}</span>
                        <span> (incl. Interest and Insurance Premium Tax)</span>
                        {remainingAmountPresent && <p className="mb-5 mt-2">By paying off your {productWording} insurance,
                            you're saving {getAmountToDisplay(this.props.remainingInterest)} in interest charges. There are no fees on
                            doing this.</p>}
                    </div>
                    {!disableButton &&
                        <Link
                            to={remainingAmountPresent ? payOffUrl : `#`} /* TODO: WTF is that empty link */
                            id="payOffBalance"
                            className={`btn ${buttonTheme} m-auto`}>
                            Pay off my balance
                        </Link>
                    }
                </div>
            </div>
        )
    }
}
